export default "__VITE_ASSET__a32be7d9__"